<template>
  <div>
    <v-row :style="'z-index:3;margin-top:5px;height:25px;background-color:' + (required ? '#FFEDEE' : 'white') + '; border: 1px solid rgba(0, 0, 0, 0.42); border-radius:5px;'" no-gutters>
      <div class="form-group-0 adjust-label" style="z-index:4" v-if="!noLabel">
        <span v-if="label !== ''" class="item-label-0">{{ label }}</span>
        <span v-else class="" style="color:white" />
        <label class="form-group-label-0">
          <span v-if="required && !requiredMarkHidden" class="mandatory" style="font-size:x-small !important">必須</span>
        </label>
      </div>
      <v-col class="py-0 adjust-input" :cols="12" style="display: inline-flex;">
        <div class="px-0" style="display: inline-block;width:40%;max-width:100px">
          <dd-date-box-inside
            v-on="computedListeners"
            v-bind="computedProps"
            v-model="fromDate"
            label=""
            style="z-index:2"
            :readonly="readonly"
            :required="required || requiredFrom"
            :placeholder="phtext"
            :tabindex="readonly ? -1 : 0"
            @input="setFromDate"
            @click="hideCalendar"
          />
        </div>
        <div class="px-0 pt-2" style="display: inline-block;">～</div>
        <div class="px-0" style="display: inline-block;width:40%;max-width:100px">
          <dd-date-box-inside
            v-on="computedListeners"
            v-bind="computedProps"
            v-model="toDate"
            label=""
            style="z-index:2"
            :readonly="readonly"
            :required="required || requiredTo"
            :placeholder="phtext"
            :tabindex="readonly ? -1 : 0"
            @input="setToDate"
            @click="hideCalendar"
          />
        </div>
        <div style="flex-grow: 1;"></div>
        <div class="pr-0" style="padding-top:5px;float:right;">
          <v-menu v-if="!readonly" v-model="isShowCalendar" :close-on-content-click="false" origin="top left">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                color="primary"
                elevation="0"
                tabindex=-1
                icon
                dark
                small
                @click="onIconClick">
                <v-icon style="margin-bottom: 2px;">mdi-calendar</v-icon>
              </v-btn>
            </template>
            <v-card elevation=0>
              <v-card-text>
                <v-row no-gutters>
                  <v-col :cols="8" style="border-right:0.1px solid #e8e8e8;">
                    <v-row style="background-color:#E9F1F7; height:28px" no-gutters>
                      <v-col :cols="12" class="px-1">
                        <span style="display: inline-block;width:90px;" class="px-1 input-info">選択日付：</span>
                        <span class="px-0 input-info" v-if="['00','01'].includes(pickerType)">{{pickerType === '01' ? calendarRangeDate : [undefined, null].includes(selectedFrom) ? '選択中' : selectedFrom}}</span>
                        <span class="px-1 input-info">～</span>
                        <span class="px-0 input-info" v-if="['00','02'].includes(pickerType)">{{pickerType === '02' ? calendarRangeDate : [undefined, null].includes(selectedTo) ? '選択中' : selectedTo}}</span>
                      </v-col>
                    </v-row>
                    <hr style="border-top:0.1px solid #c8c8c8;" />
                    <v-row style="background-color:#FFF; height:25px" no-gutters>
                      <v-col :cols="12" class="px-1 py-0">
                        <span style="display: inline-block;width:80px;" class="px-1 input-info">指定方法：</span>
                        <span style="display: inline-block;">
                          <v-radio-group v-if="useMode === 'search'" v-model="pickerType" label="" row dense>
                            <dd-radio-button
                              v-for="(item, index) in pickerActionsForSearch"
                              :key=index
                              :value="item.value"
                              :label="item.label"
                              style="margin-right: 10px !important;"
                              @change="onChangePickerType(item.value)"
                            />
                          </v-radio-group>
                          <v-radio-group v-else v-model="pickerType" label="" row dense>
                            <dd-radio-button
                              v-for="(item, index) in pickerActionsForInput"
                              :key=index
                              :value="item.value"
                              :label="item.label"
                              style="margin-right: 10px !important;"
                              @change="onChangePickerType(item.value)"
                            />
                          </v-radio-group>
                        </span>
                      </v-col>
                    </v-row>
                    <hr style="border-top:0.1px solid #e8e8e8;" />
                    <vc-date-picker
                      ref="vcCalendar"
                      v-model="calendarRangeDate"
                      style="border: none"
                      :columns="$screens({ default: 1, lg: 2 })"
                      :step="1"
                      :model-config="modelConfig"
                      :is-range="isRange"
                      @dayclick="onCalendarClick"
                      @input="onCalendarInput"
                      @popoverDidShow="handleShow"
                    />
                    <hr style="border-top:0.1px solid #e8e8e8;" />
                    <v-row class="mt-1 px-2" style="background-color:#FFF; height:35px" no-gutters>
                      <dd-custom-button dark dense @click="hideCalendar">適用</dd-custom-button>
                      <dd-transparent-button :minWidth="80" @click="isShowCalendar = false">キャンセル</dd-transparent-button>
                    </v-row>
                  </v-col>
                  <v-col :cols="4" class="px-1 py-2">
                    <v-row no-gutters justify="center">
                      <div v-for="(support, index) in supportActions" :key="index">
                        <span v-if="support.usePicker === null || support.usePicker === pickerType">
                          <input type="radio" v-model="selectedSupport" :id="support.value" name="support" :value="support.label" @click="onClickSupportAction(support.value)" />
                          <label class="support" :for="support.value">
                            {{ support.label }}
                          </label>
                        </span>
                      </div>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-menu>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { VTextField } from 'vuetify/lib'
import inputMixin from '@/mixins/inputMixins'
import date from '@/ddv2.library/date'

import DdCustomButton from '@/components/DdCustomButton'
import DdDateBoxInside from '@/components/DdDateBoxInside'
import DdRadioButton from '@/components/DdRadioButton'
import DdTransparentButton from '@/components/DdTransparentButton'

/**
 * @file DDv2用日付入力
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須有無
 * @vue-prop {String} [max='']- 許容最大値(デフォルト:2999/12/31)
 * @vue-prop {String} [min=''] - 許容最小値(デフォルト:2000/01/01)
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-text-field/
 * @example
  <dd-date-box
    label="適用開始日"
    v-model="dateValue"
    max="2099/12/31"
    min="2000/01/01"/>
 */
export default {
  name: 'DdDateRangeBox',
  extends: VTextField,
  components: {
    DdCustomButton,
    DdDateBoxInside,
    DdRadioButton,
    DdTransparentButton
  },
  mixins: [inputMixin],
  props: {
    /**
     * ラベル
     */
    label: String,
    /*
     * From日付
     */
    fromDate: {
      type: String,
      default: ''
    },
    /**
     * To日付
     */
    toDate: {
      type: String,
      default: ''
    },
    /**
     * 必須指定
     */
    required: {
      type: Boolean,
      default: false
    },
    /**
     * 必須指定(FROMのみ)
     * Required優先
     */
    requiredFrom: {
      type: Boolean,
      default: false
    },
    /**
     * 必須指定(TOのみ)
     * Required優先
     */
    requiredTo: {
      type: Boolean,
      default: false
    },
    /**
     * 入力可能最大値
     */
    max: String,
    /**
     * 入力可能最小値
     */
    min: String,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * タイトル表示
     */
    no_title: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップテキスト
     */
    tooltipText: {
      type: String,
      default: ''
    },
    /**
     * ツールチップ表示要否
     */
    enableToolTip: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップ表示位置（左）
     */
    tooltipLeft: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（上）
     */
    tooltipTop: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（右）
     */
    tooltipRight: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（下）
     */
    tooltipBottom: {
      type: Boolean,
      default: false
    },
    /**
     * ラベル別
     */
    inputGroup: {
      type: Boolean,
      default: true
    },
    /**
     * ラベル不要
     */
    noLabel: {
      type: Boolean,
      default: false
    },
    /**
     * 必須マーク非表示
     */
    requiredMarkHidden: {
      type: Boolean,
      default: false
    },
    /**
     * defaultPickerType
     * 01:期間,02:From,03:To
     */
    defaultPickerType: {
      type: String,
      default: ''
    },
    /**
     * 使用モード
     * ---------------------------------------------
     * 選択時のラジオボタンの表記が変わります。
     * 未指定時は検索用
     * ---------------------------------------------
     */
    useMode: {
      type: String,
      default: 'search'
    }
  },
  data: () => ({
    phtext: '',
    hasFocus: false,
    invalidMessage: '',
    innerValue: '',
    isShowCalendar: false,
    rangeDate: [null, null],
    defaultMax: '2999/12/31',
    defaultMin: '2000/01/01',
    pickerType: '00',
    pickerCloseFlg: false,
    selectedFrom: null,
    selectedTo: null,
    selectedMode: 0,
    calendarRangeDate: { start: null, end: null },
    modelConfig: {
      type: 'string',
      mask: 'YYYY-MM-DD'
    },
    selectedSupport: null,
    pickerActionsForSearch: [
      { value: '00', label: '範囲を指定' },
      { value: '01', label: '指定日以降を対象' },
      { value: '02', label: '指定日以前を対象' }
    ],
    pickerActionsForInput: [
      { value: '00', label: '範囲を指定' },
      { value: '01', label: '開始日のみ指定' },
      { value: '02', label: '終了日のみ指定' }
    ],
    supportActions: [
      { value: 'today', label: '今日', usePicker: null },
      { value: 'yesterday', label: '昨日', usePicker: null },
      { value: 'last7Days', label: '過去7日間(今日を含まない)', usePicker: '00' },
      { value: 'thisMonth', label: '今月', usePicker: '00' },
      { value: 'thisMonthWithoutToday', label: '今月(前日まで)', usePicker: '00' },
      { value: 'prevMonth', label: '先月', usePicker: '00' }
    ]
  }),
  created () {
    if (this.defaultPickerType !== '') this.pickerType = this.defaultPickerType
  },
  mounted () {
  },
  computed: {
    computedProps () {
      return {
        ...this.$props
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    calendarMax () {
      if (this.max) {
        return this.max.split('/').join('-')
      }
      return undefined
    },
    calendarMin () {
      if (this.min) {
        return this.min.split('/').join('-')
      }
      return undefined
    },
    isRange () {
      return this.pickerType === '00'
    }
  },
  methods: {
    onIconClick: function (e) {
      console.log('DdcalendarRangeDateBox.onIconClick fromDate - toDate : ', this.fromDate, this.toDate)
      this.selectedMode = 0
      if (this.pickerType === '00') {
        if (![undefined, null, ''].includes(this.fromDate)) {
          this.calendarRangeDate.start = this.fromDate.split('/').join('-')
          this.selectedFrom = this.fromDate.split('/').join('-')
        }
        if (![undefined, null, ''].includes(this.toDate)) {
          this.calendarRangeDate.end = this.toDate.split('/').join('-')
          this.selectedTo = this.toDate.split('/').join('-')
        }
      } else if (this.pickerType === '01') {
        if (![undefined, null, ''].includes(this.fromDate)) {
          this.calendarRangeDate = this.fromDate.split('/').join('-')
        }
      } else if (this.pickerType === '02') {
        if (![undefined, null, ''].includes(this.toDate)) {
          this.calendarRangeDate = this.toDate.split('/').join('-')
        }
      }
    },
    onCalendarClick: function (e) {
      console.log(e)
      console.log('calendarRangeDate is ', this.calendarRangeDate, ' - selectedMode is ', this.selectedMode)
      this.pickerCloseFlg = true

      if (this.pickerType === '00') {
        // from-to入れ替え
        if (this.calendarRangeDate.start > this.calendarRangeDate.end) {
          var tmpFrom = this.calendarRangeDate.start
          var tmpTo = this.calendarRangeDate.end
          this.calendarRangeDate.start = tmpTo
          this.calendarRangeDate.end = tmpFrom
        }
        if (![undefined, null, ''].includes(this.calendarRangeDate.start)) {
          this.$emit('update:fromDate', this.calendarRangeDate.start.split('-').join('/'))
          if (this.selectedMode === 0 && ![undefined, null].includes(e)) {
            this.selectedFrom = e.id.split('-').join('/')
            this.selectedMode = 1
          }
        } else {
          if ([undefined, null].includes(this.selectedFrom) && ![undefined, null].includes(e)) {
            this.selectedFrom = e.id.split('-').join('/')
            this.selectedMode = 1
          }
        }
        if (![undefined, null, ''].includes(this.calendarRangeDate.end)) {
          this.$emit('update:toDate', this.calendarRangeDate.end.split('-').join('/'))
          if (this.selectedMode === 1 && ![undefined, null].includes(e)) {
            this.selectedTo = e.id.split('-').join('/')
            this.selectedMode = 0
          }
        }
      } else if (this.pickerType === '01') {
        this.$emit('update:fromDate', this.calendarRangeDate.split('-').join('/'))
        this.$emit('update:toDate', null)
      } else if (this.pickerType === '02') {
        this.$emit('update:fromDate', null)
        this.$emit('update:toDate', this.calendarRangeDate.split('-').join('/'))
      }
    },
    onCalendarInput: function (e) {
      if (this.pickerCloseFlg) {
        this.isShowCalendar = false
      } else {
        this.pickerCloseFlg = true
      }
    },
    hideCalendar: function (e) {
      this.isShowCalendar = false
    },
    setFromDate: function (e) {
      console.log('setFromDate :', e)
      this.$emit('update:fromDate', e)
    },
    setToDate: function (e) {
      console.log('setToDate :', e)
      this.$emit('update:toDate', e)
    },
    onChangePickerType: function (pickerType) {
      this.pickerCloseFlg = false
      if (pickerType === '00') {
        if (![undefined, null, ''].includes(this.calendarRangeDate)) {
          const tmpRangeDate = {
            start: this.calendarRangeDate,
            end: this.calendarRangeDate
          }
          this.calendarRangeDate = null
          this.calendarRangeDate = Object.assign({}, tmpRangeDate)
          this.selectedFrom = null
          this.selectedTo = null
          this.selectedMode = 0
        }
      } else if (pickerType === '01') {
        if (![undefined, null, ''].includes(this.calendarRangeDate.start)) {
          this.calendarRangeDate = this.calendarRangeDate.start
        }
      } else if (pickerType === '02') {
        if (![undefined, null, ''].includes(this.calendarRangeDate.end)) {
          this.calendarRangeDate = this.calendarRangeDate.end
        }
      }

      /* 呼び出し元に反映 */
      this.syncParent(pickerType)
    },
    /**
     * 入力補助
     */
    onClickSupportAction: function (val) {
      console.log(val)
      this.pickerCloseFlg = false

      if (val === 'today') {
        if (this.pickerType === '00') {
          this.setRangeDate(date.getCurrentDate(), date.getCurrentDate())
        } else {
          this.calendarRangeDate = date.getCurrentDate()
        }
      } else if (val === 'yesterday') {
        if (this.pickerType === '00') {
          this.setRangeDate(date.getAnyDate(-1), date.getAnyDate(-1))
          this.selectedMode = 0
        } else {
          this.calendarRangeDate = date.getAnyDate(-1)
        }
      } else if (val === 'last7Days') {
        if (this.pickerType === '00') {
          this.setRangeDate(date.getAnyDate(-7), date.getAnyDate(-1))
          this.selectedMode = 0
        }
      } else if (val === 'thisMonth') {
        if (this.pickerType === '00') {
          const d = new Date()
          this.setRangeDate(date.getFirstDate(d.getFullYear(), d.getMonth() + 1), date.getLastDate(d.getFullYear(), d.getMonth() + 1))
          this.selectedMode = 0
        }
      } else if (val === 'thisMonthWithoutToday') {
        if (this.pickerType === '00') {
          const d = new Date()
          this.setRangeDate(date.getFirstDate(d.getFullYear(), d.getMonth() + 1), date.getAnyDate(-1))
          this.selectedMode = 0
        }
      } else if (val === 'prevMonth') {
        if (this.pickerType === '00') {
          const d = new Date()
          this.setRangeDate(date.getFirstDate(d.getFullYear(), d.getMonth()), date.getLastDate(d.getFullYear(), d.getMonth()))
          this.selectedMode = 0
        }
      }

      /* 呼び出し元に反映 */
      this.syncParent(this.pickerType)

      this.$refs.vcCalendar.adjustPageRange()
    },
    syncParent: function (pickerType) {
      /* 呼び出し元に反映 */
      if (pickerType === '00') {
        this.$emit('update:fromDate', this.calendarRangeDate.start.split('-').join('/'))
        this.$emit('update:toDate', this.calendarRangeDate.end.split('-').join('/'))
      } else if (pickerType === '01') {
        this.$emit('update:fromDate', this.calendarRangeDate.split('-').join('/'))
        this.$emit('update:toDate', null)
      } else if (pickerType === '02') {
        this.$emit('update:fromDate', null)
        this.$emit('update:toDate', this.calendarRangeDate.split('-').join('/'))
      }
    },
    setRangeDate: function (from, to) {
      const tmpRangeDate = {
        start: from,
        end: to
      }
      this.calendarRangeDate = Object.assign({}, tmpRangeDate)
      this.selectedFrom = from
      this.selectedTo = to
      this.selectedMode = 0
    },
    handleShow () {
      this.$refs.calendar.adjustPageRange()
    }
  }
}
</script>
<style scoped>
.adjust-label {
  margin-top: -13px !important;
  margin-left: 6px !important;
}
.adjust-input {
  margin-top: -13px !important;
}
.v-picker.v-card.v-picker--date {
  position: absolute;
  z-index: 500;
}
.mdi-calendar::before {
  color: #2196F3;
}
.v-menu__content.theme--light {
  width: 760px !important;
  height: 368px !important;
  background-color: #FFF;
}
.radio-inline__input {
    clip: rect(1px, 1px, 1px, 1px);
    position: absolute !important;
}
.radio-inline__label {
    display: inline-block;
    padding: 0.5rem 1rem;
    margin-right: 18px;
    border-radius: 3px;
    transition: all .2s;
}
.radio-inline__input:checked + .radio-inline__label {
    background: #B54A4A;
    color: #fff;
    text-shadow: 0 0 1px rgba(0,0,0,.7);
}
.radio-inline__input:focus + .radio-inline__label {
    outline-color: #4D90FE;
    outline-offset: -2px;
    outline-style: auto;
    outline-width: 5px;
}
.input-info {
  font-size:small;
  font-weight:bold;
}
/** 指定方法用 */
::v-deep .v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 1px !important;
}
::v-deep .v-radio>.v-label{
    padding-top: 1px !important;
    font-size:0.625rem !important;
    font-weight: bold !important;
}
/** 入力補助用 */
.support {
  margin: 1px;
  width: 230px;
  background: #f8f8f8;
  color: #1F2B38;
  padding: 5px 10px;
  border-radius: 3px;
  display: inline-block;
  cursor: pointer;
}
input[type="radio"] {
  display: none;
}
input[name="support"]:hover + label {
  background-color: #e0e8ff;
  font-weight: bold;
}
input[name="support"]:checked + label {
  background-color: #00ffff;
  font-weight: bold;
}
</style>
